import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { redirectCoupon } from "../Apis";
import { AdminLogo } from "../Assets/Images";


const RedirectCoupon = () => {
     const [couponvalue, setCouponvalue] = useState<any>({});
   const location = useLocation();
   const queryParams = new URLSearchParams(location.search);
   const qrValue = queryParams.get("qr");

   const getCoupon = async () => {
     const params = { coupon_code: qrValue };
     await redirectCoupon(params)
       .then((res: any) => {
         setCouponvalue(res);
       })
       .catch((error) => {
         console.log(error);
       });
   };

   useEffect(() => {
     getCoupon();
   }, []);

  return (
    <div style={{ backgroundColor: "#FFFFFF" }}>
    <div className="row g-0">
      <div className="col-md-6 login-page-content">
        {/* <img style={{ padding: "50px", width: "370px" }} src={BZLogoWhite} alt='img' /> */}
        <div
          className="mb-3 d-flex align-items-center"
          style={{ position: "absolute", bottom: 0, left: "15%" }}
        >
          <span style={{ color: "#fff", fontSize:"16px !important" }} className="me-2 mt-1" >Powered By : </span>
          <img src={AdminLogo} alt='img' />
        </div>
      </div>
       <div
       className="col-md-6 d-flex justify-content-center align-items-center"
       style={{ flexDirection : "column" }}
     >
       
         <h4>SCAN QR CODE</h4>
         <p style={{ padding: "0px 45px", fontSize : "14px" }}>
         Earn rewards by scanning with BZ App
         </p>
         {
           couponvalue?.data?.qr &&
           <>
           <img
           style={{ width: 389}}
           src={couponvalue?.data?.qr}
         /> 
         <h5 style={{marginTop : "-10px"}} className="mb-4">{qrValue}</h5>
         </>
         || 
         <h4 className="mt-5 mb-5">{couponvalue?.message}</h4>
         }
       </div>
    </div>
  </div>
  )
}

export default RedirectCoupon
